/**
 * The Drivers screens' URL-borne search, read eagerly by the route table (so it stays tiny).
 * Route-table code, not a screen: it sits beside index.ts, outside routes/, because
 * everything under routes/ must load on demand (BND-01, SF-BUNDLE).
 */

export type DriverFilterId = "all" | "available" | "unavailable" | "archived";

export interface DriversSearch {
  q?: string;
  filter?: DriverFilterId;
}

export const DRIVER_FILTERS: Array<{ id: DriverFilterId; label: string }> = [
  { id: "all", label: "All" },
  { id: "available", label: "Available" },
  { id: "unavailable", label: "Unavailable" },
  { id: "archived", label: "Archived" },
];

export function validateDriversSearch(raw: Record<string, unknown>): DriversSearch {
  const out: DriversSearch = {};
  if (typeof raw["q"] === "string" && raw["q"]) out.q = raw["q"];
  else if (typeof raw["q"] === "number") out.q = String(raw["q"]);
  const f = raw["filter"];
  if (typeof f === "string" && f !== "all" && DRIVER_FILTERS.some((x) => x.id === f)) out.filter = f as DriverFilterId;
  return out;
}

export interface NewDriverSearch {
  employee?: string;
}

export function validateNewDriverSearch(raw: Record<string, unknown>): NewDriverSearch {
  return typeof raw["employee"] === "string" && raw["employee"] ? { employee: raw["employee"] } : {};
}
